// src/firebase/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration for Tunno & Haubuah Wedding
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCOJO8ipZwnAp6O6Ckt_iSapXEl9YOsOJM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tunno-haubuah-wedding.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tunno-haubuah-wedding",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tunno-haubuah-wedding.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1005088542904",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1005088542904:web:c5d6522fd96f0cb8b3244d",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-ZRD5EJBCDX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;